export default "__VITE_ASSET__BgH1lAhp__"